import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router/index'
import store from './store'
import vueDebounce from 'vue-debounce'

import './plugins'
import './components'
import './filters'

Vue.use(vueDebounce, {
  listenTo: 'oninput'
});

Vue.config.productionTip = false



Vue.mixin({
  data() {
    return {
      per_page: [ 25, 50, 100, 250, 500, 1000],
    }
  }
})

new Vue({
  store,
  router,
  ...App
})

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
